// src/App.js
import './App.css';
import './css/global.css';
import React, {useEffect, useState, useMemo} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import JobDetails from './pages/job-details';
import JobList from './pages/job-list';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createContext } from 'react';
import Header from './components/header/header';
import { fetchCompany, fetchJobs } from './controllers/job-controllers';
import Footer from './components/footer/footer';
import NotFoundPage from './pages/not-found';
import ThankYouPage from './pages/thank-you-page';
import PreviewPage from './pages/preview';
import { testDomains } from './utils/utils';
import { Helmet } from "react-helmet";


export const AppContext = createContext(undefined);

export const AppConsumer = AppContext.Consumer;

function App() {
  const [companyData, setCompanyData] = useState(null)
  const [darkMode, setDarkMode] = useState(false);

  // Safely grab subdomain
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
  const subdomain = hostname.split('.').length > 2 ? hostname.split('.')[0] : ''

  const shouldNoIndex = testDomains.includes(subdomain)

  const theme = createTheme({ 
    cssVariables: true,
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: '#01579b', 
      },
    },
    typography: {
      fontFamily: '"Nunito Sans", "Helvetica", "Arial", sans-serif', // Set your desired font family here
      // You can customize other typography settings if needed
    },
  });

  const memoizedValue = useMemo(
      () => ({
        darkMode,
        setDarkMode,
      }),
      [
        darkMode,
        setDarkMode,
      ]
  );

  useEffect(() => {
    (async () => {
      try {
        const res = await fetchCompany();
        setCompanyData(res);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return (
    <AppContext.Provider value={memoizedValue}>
      {shouldNoIndex && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header company={companyData} />
        <Router>
          <Routes>
            <Route path="/" element={<JobList company={companyData} />} />
            <Route path="/job/:id" element={<JobDetails company={companyData} />}  />
            <Route path="/job/preview/:id" element={<PreviewPage company={companyData} />}  />
            <Route path='/thank-you' element={<ThankYouPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
        <Footer />
      </ThemeProvider>
    </AppContext.Provider>
  );
}

export default App;
